import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import { useDispatch, useSelector } from 'react-redux';
import ModalComponent from '../../../../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../../../../contexts/ModalContext/ModalContext';
import { createTag } from '../../../../../redux/slices/tagListSlice/tagListSlice';
import { selectSessionInformation } from '../../../../../redux/slices/sessionSlice';

function NewTagModal({ setModalJSX }) {
  const dispatch = useDispatch();
  const { activeSubscription } = useSelector(selectSessionInformation);
  const [show, setShow] = useState(true);
  const [error, setError] = useState('');
  const [tagName, setTagName] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    if (tagName.length < 1 || tagName.length > 100) {
      setError('Tag must be between 1 and 100 characters long.');
      setSubmitting(false);
      return false;
    }
    const tagData = {
      subscriptionId: activeSubscription.id,
      tag: {
        name: tagName,
        deviceTagList: [],
        alertTagList: [],
      },
    };
    try {
      await dispatch(createTag(tagData)).unwrap();
      closeModalHandler();
      setSubmitting(false);
    } catch (err) {
      setError(err.data[0] ? err.data[0].message : 'Unexpected error saving new tag. Please try again.');
      setSubmitting(false);
    }
    return true;
  };

  /* istanbul ignore next */
  return (
    <ModalComponent
      showConfirmCallToAction
      show={show}
      close={closeModalHandler}
      confirmButtonText="Save"
      confirmButtonAction={handleSubmit}
      isBtnDisabled={submitting}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create New Tag</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="px-3">
          <form>
            {error && (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={() => setError('')}>
                  {error}
                </ErrorBanner>
              </div>
            </div>
            )}
            <div className="form-group row justify-content-center">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label
                className="col-sm-2 col-form-label text-right"
                htmlFor="newTagInput"
              >
                Tag
              </label>
              <div className="col-sm-10">
                <input
                  type="text"
                  className="form-control"
                  id="newTagInput"
                  onChange={(e) => setTagName(e.target.value)}
                  value={tagName}
                />
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
}

NewTagModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
};

export { NewTagModal };
export default connectModalContainerContextToComponent(NewTagModal);
